// @flow

import React from 'react'

// Redux
import { connect } from 'react-redux'

import Analytics from './Analytics'

class AnalyticsManager extends React.Component {

  constructor(props : Object) {
    super(props)

    this.setValues(props)
  }

  componentWillReceiveProps(nextProps) {
    this.setValues(nextProps)
  }

  setValues(props) {
    const appInfo = Object.assign({}, props.appInfo)

    if (props.userId){
      appInfo.userId = props.userId
    }

    if (props.teamId){
      appInfo.teamId = props.teamId
    }

    Analytics.appInfo = appInfo
  }

  render () {
    return null
  }

}

function mapStateToProps(state) {
  const props = {
    appInfo: state.analytics,
    userId: state.firebase.userAuth.id,
  }

  const userInfo = state.firebase.user
  const userTeams = userInfo && userInfo.teams
  if (!userTeams || userTeams.loading) {
    return props
  }

  // Just sync first team
  // TODO move this to a selectionTeam key inside redux
  if (userTeams.value && userTeams.value.length > 0) {
    props.teamId = userTeams.value[0].teamId
  }
  return props
}

export default connect(mapStateToProps)(AnalyticsManager)



// WEBPACK FOOTER //
// ./src/infra/analytics/AnalyticsManager.js